export const GroupStep = {
  GROUP: 'group',
  GEO_AREA: 'geo-area'
} as const;

export type GroupStep = (typeof GroupStep)[keyof typeof GroupStep];
